import * as React from 'react';
import { useContext, useReducer, useState, useEffect } from "react";

import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";

import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import  * as uuidv4 from "uuid/v4";
import log from 'loglevel';

import { Item } from "./Item";
import { ItemsDataList } from "./itemsDataList";
import { containerStyle, itemStyle, columnStyle1 } from "./ItemsContainer.Styles";
/**
 * 
 * 
 */
export const ItemsContainer = () => {

  const { dispatch, state } = useContext(MessagesContext);
  const [allSelected, setAllSelected] = useState(false);    

  log.info(` @ItemsContainer`)

  const stateMessagesLength = state.messages.length;
  const title = stateMessagesLength > 0 ? `${stateMessagesLength} Messages`
      : "No Messages Selected!";
  
  
  return (
     <div style={containerStyle()}>       
        {
          <ItemsDataList />
        }
      </div>
  );
};




// const SelectedMessagesCommandBar = () => {

    // return (
    //   <div key={2} style={itemStyle()}>
    //     {
    //       <>
    //         <div style={columnStyle1()}>
    //           {`Act on Selected Messages ( ${state.messages.length} listed):`}
    //         </div>

    //         <div
    //           onClick={() => {
    //                 let reducerType = allSelected ? "SELECT_ALL_MESSAGES" : "UNSELECT_ALL_MESSAGES";
    //                 dispatch({ type: reducerType, payload: {} })
    //                 setAllSelected(!allSelected); 
    //               }
    //           }
    //         >
    //           Toggle
    //         </div>
    //       </>
    //     }
    //   </div>
    // );

